import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import ButtonCircle from "../../../../components/Common/ButtonCircle";
import {MissingType} from "../../../../db/models/extra";
import EditIcon from "@material-ui/icons/Edit";
import ClearIcon from "@material-ui/icons/Clear";
import {updateUserDisplayName} from "../../../../api/auth";
import {openAlert} from "../../../../slices/alert";
import Button from "../../../../components/Common/Button";
import {useTranslation} from "react-i18next";
import {selectName} from "../../../../slices/profile";

export const StudentSettingsName = () => {
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const {register, handleSubmit, errors, reset} =
        useForm<MissingType>({
            defaultValues: {
                name,
                surname,
            },
        });
    const [editName, setEditName] = useState(false);
    const displayName = useSelector(selectName);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        if (!displayName) return;

        const split = displayName.split("_");
        const name = split[0];
        const surname = split[1];

        setName(name);
        setSurname(surname);

        reset({
            name,
            surname,
        });
    }, [displayName, reset]);

    const onSaveName = (form: MissingType) => {
        const newName = form.name;
        const newSurname = form.surname;

        // go on only if data changed
        if (name === newName && surname === newSurname) return;

        const displayName = newName + "_" + newSurname;

        updateUserDisplayName(displayName).then(() => {
            setEditName(false);
            // update form names
            reset({
                name: newName,
                surname: newSurname,
            });

            //update static name
            setName(newName);
            setSurname(newSurname);

            //set alert
            dispatch(
                openAlert({type: "success", message: t("alert_name_updated")})
            );
        });
    };

    return (
        <div className="studentSettingsName  mb30">
            <div className="studentSettingsName__header">
                <label className="label">{t("student_settings_name")}</label>
                {!editName && (
                    <ButtonCircle light onClick={() => setEditName(true)}>
                        <EditIcon/>
                    </ButtonCircle>
                )}
                {editName && (
                    <ButtonCircle light onClick={() => setEditName(false)}>
                        <ClearIcon/>
                    </ButtonCircle>
                )}
            </div>
            {!editName && (
                <p className="body">
                    {name} {surname}
                </p>
            )}
            {editName && (
                <form onSubmit={handleSubmit(onSaveName)}>
                    <div className="element">
                        <div className="label">{t("student_settings_name_label")}</div>
                        <input
                            type="text"
                            placeholder={t("student_settings_name_ph")}
                            name="name"
                            ref={register({required: true})}
                        />
                        {errors.name && <span className="error">{t("student_settings_name_error")}</span>}
                    </div>
                    <div className="element">
                        <div className="label">{t("student_settings_surname_label")}</div>
                        <input
                            type="text"
                            placeholder={t("student_settings_surname_ph")}
                            name="surname"
                            ref={register({required: true})}
                        />
                        {errors.surname && (
                            <span className="error">{t("student_settings_surname_error")}</span>
                        )}
                    </div>
                    <Button type="submit">{t("student_settings_name_submit")}</Button>
                </form>
            )}
        </div>
    );
};
